import { z } from 'zod';

/**
 * §3 ТЗ. Словарь прав, общий для сервера и SPA.
 *
 * Сама матрица «роль → права» живёт только на сервере (`apps/api/.../rbac.ts`):
 * фронт получает готовый список прав в `GET /api/session/bootstrap` и ничего
 * не выводит из роли самостоятельно. Здесь — только имена прав, чтобы
 * рассинхрон между сервером и интерфейсом ловил компилятор.
 *
 * Скрытие пункта меню по праву — удобство, а не контроль доступа: решение
 * всё равно принимает сервер в каждом хендлере (§3).
 */
export const PERMISSIONS = [
  'projects.read',
  'projects.write',
  'people.read',
  'people.write',
  'people.revoke',
  'invites.read',
  'invites.write',
  'surveys.read',
  'surveys.write',
  'results.read',
  'results.status',
  'employees.read',
  'employees.write',
  'integration.read',
  'integration.retry',
  'audit.read',
  'dashboard.read',
] as const;

export const PermissionSchema = z.enum(PERMISSIONS);
export type Permission = z.infer<typeof PermissionSchema>;
